import { defineMessages } from 'react-intl';

export default defineMessages({
  contactSuccessTitle: {
    id: 'contactModal.contactSuccessTitle',
    defaultMessage: 'Thanks for your enquiry!',
  },
  contactSuccessText: {
    id: 'contactModal.contactSuccessText',
    defaultMessage: 'Our friendly XCover team will respond via email shortly.',
  },
  contactTitle: {
    id: 'contactModal.contactPurpose.contactTitle',
    defaultMessage: 'What do you need help with?',
  },
  articlesTitle: {
    id: 'contactModal.contactPurpose.articlesTitle',
    defaultMessage: 'Here are some helpful articles.',
  },
  allArticlesButtonText: {
    id: 'contactModal.contactPurpose.allArticlesButtonText',
    defaultMessage: 'view all articles',
  },
  moreQuestionsButtonText: {
    id: 'contactModal.contactPurpose.moreQuestionsButtonText',
    defaultMessage: 'Have more questions?',
  },
  emailUsButtonText: {
    id: 'contactModal.contactPurpose.emailUsButtonText',
    defaultMessage: 'Email us',
  },
  placeholder: {
    id: 'contactModal.contactPurpose.placeholder',
    defaultMessage: 'Select',
  },
  protectionTitle: {
    id: 'contactModal.partnerHeader.protectionTitle',
    defaultMessage: 'Your Protection',
  },
  protectionText: {
    id: 'contactModal.partnerHeader.protectionText',
    defaultMessage: '{partnerName} protection',
  },
  partnersTitle: {
    id: 'contactModal.partnersCard.partnersTitle',
    defaultMessage: 'Hello!',
  },
  partnersTitle2: {
    id: 'contactModal.partnersCard.partnersTitle2',
    defaultMessage: 'You’ve got XCover from these partners. Please choose one!',
  },
});
